import { render, staticRenderFns } from "./LessonQuiz.vue?vue&type=template&id=0abeb554"
import script from "./LessonQuiz.vue?vue&type=script&lang=js"
export * from "./LessonQuiz.vue?vue&type=script&lang=js"
import style0 from "./LessonQuiz.vue?vue&type=style&index=0&id=0abeb554&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports